import { IconProps } from "./type";

const AccountSettingsIcon = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6047 4.71053C10.6047 3.59383 10.161 2.52286 9.37142 1.73324C8.58179 0.943608 7.51083 0.5 6.39412 0.5C5.27742 0.5 4.20646 0.943608 3.41683 1.73324C2.6272 2.52286 2.18359 3.59383 2.18359 4.71053C2.18359 5.82723 2.6272 6.8982 3.41683 7.68783C4.20646 8.47745 5.27742 8.92106 6.39412 8.92106C7.51083 8.92106 8.58179 8.47745 9.37142 7.68783C10.161 6.8982 10.6047 5.82723 10.6047 4.71053Z"
        stroke="#E1E1E1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.5 14.8159C0.499795 13.8213 0.751228 12.8429 1.23089 11.9717C1.71056 11.1004 2.40286 10.3647 3.24336 9.83302C4.08385 9.30133 5.04521 8.99093 6.03793 8.93073C7.03066 8.87053 8.02248 9.06248 8.92106 9.48872M13.5526 11.0264C14.3358 11.0264 15.0179 11.4534 15.38 12.0875C15.5569 12.3948 15.6579 12.751 15.6579 13.1317C15.6579 13.5123 15.5569 13.8685 15.3809 14.1759C15.1967 14.4982 14.9306 14.7662 14.6096 14.9525C14.2885 15.1388 13.9239 15.237 13.5526 15.2369C13.1814 15.237 12.8168 15.1388 12.4957 14.9525C12.1746 14.7662 11.9086 14.4982 11.7244 14.1759C11.5484 13.8685 11.4474 13.5123 11.4474 13.1317C11.4474 12.751 11.5484 12.3948 11.7253 12.0875C12.0874 11.4534 12.7695 11.0264 13.5526 11.0264ZM15.38 12.0875L16.5 11.4475M15.3809 14.1759L16.5 14.8159M13.5526 15.2369V16.5001M11.7253 12.0875L10.6053 11.4475M11.7244 14.1759L10.6053 14.8159M13.5526 11.0264V9.76325"
        stroke="#E1E1E1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AccountSettingsIcon;
